// Utility functions
function assertALowerB(
  A,
  AName,
  B,
  BName,
  id,
  ownerId,
  stepId,
  incorrectValues,
  isError = true
) {
  const key = isError ? "errors" : "warnings";
  if (A > B) {
    if (!incorrectValues[id]) {
      incorrectValues[id] = {
        [key]: [],
        owner: ownerId,
      };
    }
    incorrectValues[id][key].push({
      step: stepId,
      fieldName: AName,
      // value: A,
      message: `${AName} is greater than ${BName}`, //: (${A} > ${B})
    });
  }
}

function assertADifferentB(
  A,
  AName,
  B,
  BName,
  id,
  ownerId,
  stepId,
  incorrectValues,
  isError = true
) {
  const key = isError ? "errors" : "warnings";
  if (A === B) {
    if (!incorrectValues[id]) {
      incorrectValues[id] = {
        [key]: [],
        owner: ownerId,
      };
    }
    incorrectValues[id][key].push({
      step: stepId,
      fieldName: AName,
      // value: A,
      message: `${AName} is equal to ${BName}`, //: (${A} == ${B})
    });
  }
}

function checkConsistency(
  stepId,
  fields,
  id,
  ownerId,
  conditions,
  prefix,
  incorrectValues
) {
  conditions.forEach((condition) => {
    const baseValue =
      (fields.find((x) => x.name === `${prefix}_${condition}`) || {}).value ||
      0;
    const adfValue =
      (fields.find((x) => x.name === `${prefix}_${condition}_ADF`) || {})
        .value || 0;
    const enablerValue =
      (
        fields.find((x) => x.name === `${prefix}_${condition}_ADF_Enabler`) ||
        {}
      ).value || 0;

    if (prefix !== "") {
      assertALowerB(
        adfValue,
        `${prefix}_${condition}_ADF`,
        baseValue,
        `${prefix}_${condition}`,
        id,
        ownerId,
        stepId,
        incorrectValues
      );
      assertALowerB(
        enablerValue,
        `${prefix}_${condition}_ADF_Enabler`,
        baseValue,
        `${prefix}_${condition}`,
        id,
        ownerId,
        stepId,
        incorrectValues
      );
    } else {
      assertALowerB(
        adfValue,
        `${condition}_ADF`,
        baseValue,
        `${condition}`,
        id,
        ownerId,
        stepId,
        incorrectValues
      );
      assertALowerB(
        enablerValue,
        `${condition}_ADF_Enabler`,
        baseValue,
        `${condition}`,
        id,
        ownerId,
        stepId,
        incorrectValues
      );
    }
  });
}

// Single check functions (on a single field)

// Check that numerical value is greater than 0
function checkPositiveValues(
  value,
  id,
  ownerId,
  stepId,
  fieldName,
  incorrectValues
) {
  if (typeof value === "number" && value < 0) {
    if (!incorrectValues[id]) {
      incorrectValues[id] = {
        errors: [],
        owner: ownerId,
      };
    }
    incorrectValues[id].errors.push({
      step: stepId,
      fieldName: fieldName,
      value: value,
      message: "Value is not greater than 0",
    });
  }
}

// Check that histograms are not too long
function checkHistLength(
  value,
  id,
  ownerId,
  stepId,
  fieldName,
  incorrectValues
) {
  if (
    fieldName === "vHistX" ||
    fieldName === "vHistADF" ||
    fieldName === "vHistADFEnabler"
  ) {
    if (value.length > 50) {
      if (!incorrectValues[id]) {
        incorrectValues[id] = {
          errors: [],
          owner: ownerId,
        };
      }
      incorrectValues[id].errors.push({
        step: stepId,
        fieldName: fieldName,
        // value: value,
        message: `Histogram is too long, length: ${value.length}`,
      });
    }
  }
}

// Cross-check functions (within the same group)

function checkGenderConsistency(stepId, fields, id, ownerId, incorrectValues) {
  const participantAll =
    (fields.find((x) => x.name === "Participant_all") || {}).value || 0;
  const participantMale =
    (fields.find((x) => x.name === "Participant_male") || {}).value || 0;
  const participantFemale =
    (fields.find((x) => x.name === "Participant_female") || {}).value || 0;
  const participantUnknown =
    (fields.find((x) => x.name === "Participant_unknown") || {}).value || 0;

  if (
    participantAll !==
    participantFemale + participantMale + participantUnknown
  ) {
    if (!incorrectValues[id]) {
      incorrectValues[id] = {
        errors: [],
        owner: ownerId,
      };
    }
    incorrectValues[id].errors.push({
      step: stepId,
      fieldName: "Participant_all",
      // value: participantAll,
      message: `Participant_all: ${participantAll} is not consistent with the sum of the participants: (male: ${participantMale}, female: ${participantFemale}, unknown: ${participantUnknown})`,
    });
  }
}

function checkRoadConditionConsistency(
  stepId,
  fields,
  id,
  ownerId,
  incorrectValues
) {
  checkConsistency(
    stepId,
    fields,
    id,
    ownerId,
    ["dry", "wet", "snowy", "icy"],
    "Road",
    incorrectValues
  );
}

function checkPrecipitationConsistency(
  stepId,
  fields,
  id,
  ownerId,
  incorrectValues
) {
  checkConsistency(
    stepId,
    fields,
    id,
    ownerId,
    [
      "no_rain",
      "light_rain",
      "rain",
      "heavy_rain",
      "light_snow",
      "snow",
      "heavy_snow",
      "fog",
      "cloudy",
      "sunny",
    ],
    "Weather",
    incorrectValues
  );
}

function checkLightingConsistency(
  stepId,
  fields,
  id,
  ownerId,
  incorrectValues
) {
  checkConsistency(
    stepId,
    fields,
    id,
    ownerId,
    ["daylight", "dawn", "dusk", "night"],
    "Lighting",
    incorrectValues
  );
}

function checkDistanceConsistency(
  stepId,
  fields,
  id,
  ownerId,
  incorrectValues
) {
  checkConsistency(
    stepId,
    fields,
    id,
    ownerId,
    ["overall", "motorway", "rural", "urban", "urban_motorway", "test_track"],
    "Distance",
    incorrectValues
  );
}

function checkDrivingTimeConsistency(
  stepId,
  fields,
  id,
  ownerId,
  incorrectValues
) {
  checkConsistency(
    stepId,
    fields,
    id,
    ownerId,
    ["overall", "motorway", "rural", "urban", "urban_motorway", "test_track"],
    "Time",
    incorrectValues
  );
}

function checkTravelledDistanceOnLanesConsistency(
  stepId,
  fields,
  id,
  ownerId,
  incorrectValues
) {
  checkConsistency(
    stepId,
    fields,
    id,
    ownerId,
    ["Lane_1", "Lane_2", "Lane_3", "Lane_4", "Lane_4_plus", "Sidewalk"],
    "",
    incorrectValues
  );
}

function checkTravelledDistanceSpeedLimitConsistency(
  stepId,
  fields,
  id,
  ownerId,
  incorrectValues
) {
  checkConsistency(
    stepId,
    fields,
    id,
    ownerId,
    [
      "25_less",
      "25_35",
      "35_45",
      "45_55",
      "55_65",
      "65_75",
      "75_85",
      "85_95",
      "95_105",
      "105_115",
      "115_125",
      "125_135",
      "135plus",
    ],
    "Distance",
    incorrectValues
  );
}

function checkEncounteredCrossingConsistency(
  stepId,
  fields,
  id,
  ownerId,
  incorrectValues
) {
  checkConsistency(
    stepId,
    fields,
    id,
    ownerId,
    [
      "Intersection_no_signs",
      "Insersection_signs",
      "Intersection_traffic_light",
      "On_ramp",
      "Off_ramp",
      "On_ramp_passing",
      "Construction",
      "Roundabout",
      "Pedestrian_crossing",
      "Traffic_Light",
      "Tunnel",
    ],
    "",
    incorrectValues
  );
}

// Cross-check functions (between different groups)

function checkDsConsistency(stepId, fields, id, ownerId, incorrectValues) {
  const fieldNames = [
    "DS_lane_change",
    "DS_turn_left",
    "DS_turn_right",
    "DS_crossing_intersection",
    "DS_motorway_enter",
    "DS_motorway_exit",
  ];

  fieldNames.forEach((fieldName) => {
    const baselineSignal =
      (fields.find((x) => x.name === fieldName) || {}).value || 0;
    const manualSignal =
      (fields.find((x) => x.name === fieldName + "_manual") || {}).value || 0;
    const adfSignal =
      (fields.find((x) => x.name === fieldName + "_ADF") || {}).value || 0;
    const adfEnablerSignal =
      (fields.find((x) => x.name === fieldName + "_ADF_Enabler") || {}).value ||
      0;

    assertALowerB(
      manualSignal,
      fieldName + "_manual",
      baselineSignal,
      fieldName,
      id,
      ownerId,
      stepId,
      incorrectValues
    );
    assertALowerB(
      adfSignal,
      fieldName + "_ADF",
      baselineSignal,
      fieldName,
      id,
      ownerId,
      stepId,
      incorrectValues
    );
    assertALowerB(
      adfEnablerSignal,
      fieldName + "_ADF_Enabler",
      baselineSignal,
      fieldName,
      id,
      ownerId,
      stepId,
      incorrectValues
    );
  });
}

function checkNumberOperationTimeAdfConsistency(
  stepId,
  fields,
  id,
  ownerId,
  incorrectValues
) {
  const activations =
    (fields.find((x) => x.name === "Activations") || {}).value || 0;

  const adfTimes = [
    "ADF_Time_1",
    "ADF_Time_5",
    "ADF_Time_10",
    "ADF_Time_15",
    "ADF_Time_20",
    "ADF_Time_30",
    "ADF_Time_40",
    "ADF_Time_50",
    "ADF_Time_60",
    "ADF_Time_90",
    "ADF_Time_120",
    "ADF_Time_120plus",
  ];
  const adfEnablers = adfTimes.map((time) => time + "_Enabler");

  adfTimes.forEach((adfTime) => {
    const adfValue = (fields.find((x) => x.name === adfTime) || {}).value || 0;
    assertALowerB(
      adfValue,
      adfTime,
      activations,
      "Activations",
      id,
      ownerId,
      stepId,
      incorrectValues
    );
  });

  adfEnablers.forEach((adfEnabler) => {
    const adfEnablerValue =
      (fields.find((x) => x.name === adfEnabler) || {}).value || 0;
    assertALowerB(
      adfEnablerValue,
      adfEnabler,
      activations,
      "Activations",
      id,
      ownerId,
      stepId,
      incorrectValues
    );
  });
}

function checkOperationTimeAllEquals(
  stepId,
  fields,
  id,
  ownerId,
  incorrectValues,
  isError = false
) {
  const key = isError ? "errors" : "warnings";
  const adfTimes = [
    "ADF_Time_1",
    "ADF_Time_5",
    "ADF_Time_10",
    "ADF_Time_15",
    "ADF_Time_20",
    "ADF_Time_30",
    "ADF_Time_40",
    "ADF_Time_50",
    "ADF_Time_60",
    "ADF_Time_90",
    "ADF_Time_120",
    "ADF_Time_120plus",
  ];
  const adfEnablers = adfTimes.map((time) => time + "_Enabler");

  const adfValues = adfTimes.map(
    (adfTime) => (fields.find((x) => x.name === adfTime) || {}).value || 0
  );
  const adfEnablerValues = adfEnablers.map(
    (adfEnabler) => (fields.find((x) => x.name === adfEnabler) || {}).value || 0
  );

  // check if all members of the list are equal and not equal to 0
  if (adfValues.every((x) => x === adfValues[0] && x !== 0)) {
    if (!incorrectValues[id]) {
      incorrectValues[id] = {
        [key]: [],
        owner: ownerId,
      };
    }
    incorrectValues[id][key].push({
      step: stepId,
      fieldName: "ADF_times",
      // value: adfValues,
      message: "All ADF times are equal",
    });
  }

  if (adfEnablerValues.every((x) => x === adfEnablerValues[0] && x !== 0)) {
    if (!incorrectValues[id]) {
      incorrectValues[id] = {
        [key]: [],
        owner: ownerId,
      };
    }
    incorrectValues[id][key].push({
      step: stepId,
      fieldName: "ADF_times_Enabler",
      // value: adfEnablerValues,
      message: "All ADF times enablers are equal",
    });
  }
}

// Quality check functions

// Quality check wrapper
// This function is the entry point for the quality check process
// It wraps all the single check function avoiding redundancy in the code

export function qualityCheck(experiment, incorrectValues) {
  // Store useful ids
  const id = experiment["_id"];
  const ownerId = experiment["owner"];

  // Loop over the whole history
  experiment["history"].forEach((step) => {
    const stepId = step["step"];
    const fields = step["fields"];

    // Apply checks to all the fields
    fields.forEach((field) => {
      const value = field["value"];
      const fieldName = field["name"];

      // Apply all checks
      checkPositiveValues({
        value,
        id,
        ownerId,
        stepId,
        fieldName,
        incorrectValues,
      });
      checkHistLength({
        value,
        id,
        ownerId,
        stepId,
        fieldName,
        incorrectValues,
      });
    });

    // Apply checks to the step itself, applying the cross-checks to the step object
    checkRoadConditionConsistency(stepId, fields, id, ownerId, incorrectValues);
    checkPrecipitationConsistency(stepId, fields, id, ownerId, incorrectValues);
    checkLightingConsistency(stepId, fields, id, ownerId, incorrectValues);
    checkDistanceConsistency(stepId, fields, id, ownerId, incorrectValues);
    checkDrivingTimeConsistency(stepId, fields, id, ownerId, incorrectValues);
    checkTravelledDistanceOnLanesConsistency(
      stepId,
      fields,
      id,
      ownerId,
      incorrectValues
    );
    checkTravelledDistanceSpeedLimitConsistency(
      stepId,
      fields,
      id,
      ownerId,
      incorrectValues
    );
    checkEncounteredCrossingConsistency(
      stepId,
      fields,
      id,
      ownerId,
      incorrectValues
    );
    checkDsConsistency(stepId, fields, id, ownerId, incorrectValues);
    checkNumberOperationTimeAdfConsistency(
      stepId,
      fields,
      id,
      ownerId,
      incorrectValues
    );
    checkOperationTimeAllEquals(stepId, fields, id, ownerId, incorrectValues);
  });
}
